import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "next/image";
import React, { useMemo, useState } from "react";
import { StickySection } from "../../styles/ProductDetail.style";
import { AdBanner } from "@/components/Banner/AdBanner/AdBanner";
import { useBooks } from "@/components/Books/Order";
import { ExtraResourceNew } from "@/components/Product/ExtraResourceNew";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Link as ScrollLink } from "react-scroll";
import { isBooksProduct } from "src/api/booksProducts";
import { BookInfoTab, ContentsTab, DetailTab, PreviewTab, PriceTab, ProductDetailContentWrapper, ScrollSection, StyledAnchor } from "./ProductDetailContent.style";
import ProductDetailTerms from "./ProductDetailTerms";
import detailInfoList from "./detailInfoList";
var LinkTab;
(function(LinkTab) {
    LinkTab["contents"] = "contents";
    LinkTab["author"] = "author";
    LinkTab["preview"] = "preview";
    LinkTab["detail"] = "detail";
    LinkTab["refund"] = "refund";
    LinkTab["book"] = "book";
    LinkTab["bookShipRefund"] = "bookShipRefund";
    LinkTab["review"] = "review";
})(LinkTab || (LinkTab = {}));
export const ProductDetailContent = (param)=>{
    let { product , priceSection  } = param;
    const isBooks = isBooksProduct(product);
    const { isBooks: isAladinbook  } = useBooks();
    const isEbook = isBooks && !isAladinbook;
    const productType = isBooks ? product.productType : product.source_type;
    const { publisherName , brandName  } = product;
    const source = isBooks ? product : product.source;
    const { sub_items  } = source;
    const { images  } = source;
    const previewImages = images === null || images === void 0 ? void 0 : images.previews;
    const promotionImages = product && (images === null || images === void 0 ? void 0 : images.promotions) ? Array.isArray(images === null || images === void 0 ? void 0 : images.promotions) && (images === null || images === void 0 ? void 0 : images.promotions.slice().sort((a, b)=>a.order - b.order)) : [];
    const hasSubItems = useMemo(()=>{
        return sub_items && sub_items.length > 0;
    }, [
        sub_items
    ]);
    const { width  } = useWindowDimensions();
    const isMobile = width < 1200;
    const [scrollLinkOptions] = useState({
        activeClass: "active",
        smooth: true,
        offset: isMobile ? -200 : -150,
        spy: true
    });
    const TabList = [
        {
            key: "book",
            title: "도서 정보",
            render: isBooks && (product.introduction || product.tableOfContents)
        },
        {
            key: "contents",
            title: "포함된 컨텐츠",
            render: !isBooks && hasSubItems
        },
        {
            key: "author",
            title: "저자 정보",
            render: !isBooks && brandName
        },
        {
            key: "preview",
            title: "미리보기",
            render: !isBooks && previewImages
        },
        {
            key: "detail",
            title: "상세 정보",
            render: true
        },
        {
            key: "refund",
            title: "환불/교환 정보",
            render: !isBooks || isEbook
        },
        {
            key: "bookShipRefund",
            title: "배송/환불/교환 정보",
            render: isAladinbook
        }
    ];
    return /*#__PURE__*/ _jsxs(ProductDetailContentWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(ScrollSection, {
                children: [
                    /*#__PURE__*/ _jsx(StyledAnchor, {
                        children: TabList.map((tab, index)=>{
                            return tab.render ? /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(ScrollLink, {
                                    to: tab.key,
                                    ...scrollLinkOptions,
                                    onClick: ()=>mixpanelEvent("Product Detail Page Tab Clicked", {
                                            "Tab Name": tab.title
                                        }),
                                    children: tab.title
                                })
                            }, "bottom-tab-".concat(index)) : null;
                        })
                    }),
                    /*#__PURE__*/ _jsx(AdBanner, {
                        position: "productDetail",
                        mixpanelPosition: "product detail page",
                        subject: isBooks ? product.subject : product.source.subject
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "detail-content",
                        children: [
                            isEbook && /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/static/assets/".concat(isMobile ? "Mobile" : "PC", "-image-goodnote.jpg"),
                                    alt: "ebook-promotion-img"
                                })
                            }),
                            hasSubItems && /*#__PURE__*/ _jsxs(ContentsTab, {
                                name: "contents",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        children: "포함된 컨텐츠"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        children: sub_items.map((subItem, index)=>{
                                            return /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx(ExtraResourceNew, {
                                                        type: subItem.type
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: subItem.title
                                                    })
                                                ]
                                            }, "sub-item-".concat(index));
                                        })
                                    })
                                ]
                            }),
                            previewImages && /*#__PURE__*/ _jsxs(PreviewTab, {
                                name: "preview",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        children: "미리보기"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            previewImages.sort((a, b)=>a.page_num - b.page_num).map((image, index)=>{
                                                return /*#__PURE__*/ _jsx(Image, {
                                                    alt: "".concat(product.title, "_preview_").concat(image.page_num),
                                                    width: 3000,
                                                    height: 6000,
                                                    src: image.url
                                                }, "preview-image-" + index);
                                            }),
                                            promotionImages && promotionImages.map((image, index)=>{
                                                return /*#__PURE__*/ _jsx(Image, {
                                                    width: 3000,
                                                    height: 6000,
                                                    src: image.url,
                                                    alt: "product-detail-image"
                                                }, "detail-image-".concat(index));
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isBooks && (product.introduction || product.tableOfContents) && /*#__PURE__*/ _jsxs(BookInfoTab, {
                                name: "book",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        children: "도서 정보"
                                    }),
                                    product.introduction && /*#__PURE__*/ _jsxs("div", {
                                        className: "info-cell",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "title",
                                                children: "책소개"
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "content",
                                                dangerouslySetInnerHTML: {
                                                    __html: product.introduction
                                                }
                                            })
                                        ]
                                    }),
                                    product.tableOfContents && /*#__PURE__*/ _jsxs("div", {
                                        className: "info-cell",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "title",
                                                children: "목차"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "content",
                                                dangerouslySetInnerHTML: {
                                                    __html: product.tableOfContents
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(DetailTab, {
                                name: "detail",
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        children: "상세 정보"
                                    }),
                                    (product === null || product === void 0 ? void 0 : product.description) && /*#__PURE__*/ _jsx("div", {
                                        className: "wrapper description",
                                        children: product === null || product === void 0 ? void 0 : product.description
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "wrapper info-wrapper",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx("ul", {
                                                children: detailInfoList(product, isBooks ? product.publisher : publisherName).map((item, index)=>{
                                                    if (item.value === null || item.value === undefined || item.value === "0" || item.value === "") return null;
                                                    return /*#__PURE__*/ _jsxs("li", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "title",
                                                                children: item.type
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "content",
                                                                children: item.value
                                                            })
                                                        ]
                                                    }, "detail-info-".concat(index));
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(ProductDetailTerms, {
                                productType: productType
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StickySection, {
                children: /*#__PURE__*/ _jsx(PriceTab, {
                    children: priceSection
                })
            })
        ]
    });
};
